import type { ReactNode } from 'react';
import { Link, type LinkProps } from 'react-router-dom';
import {
  ButtonContent,
  type ButtonSize,
  type ButtonVariant,
  buttonClasses,
} from '../../../design-system/components';

interface LinkButtonProps extends LinkProps {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
  /** Decorative icon after the label. */
  trailingIcon?: ReactNode;
}

/**
 * A router Link with the design-system Button's look (the same classes as
 * Button, so an in-app route stays a client-side navigation instead of the
 * full page load Button's href would make), from Button's own helpers so
 * the two cannot drift. The label is the link's name.
 */
export default function LinkButton({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  trailingIcon,
  className,
  children,
  ...rest
}: LinkButtonProps) {
  return (
    <Link {...rest} className={buttonClasses({ variant, size, fullWidth, className })}>
      <ButtonContent trailingIcon={trailingIcon}>{children}</ButtonContent>
    </Link>
  );
}
